<script setup lang="ts">
import { onMounted } from 'vue'
import { useSessionStore } from '@/stores/session'

const session = useSessionStore()
onMounted(() => session.restore())
</script>

<template>
  <RouterView v-if="session.ready" />
  <main v-else class="boot-state" aria-busy="true" aria-label="جاري تحميل النظام">
    <div class="spinner" aria-hidden="true"></div>
    <p>جاري تجهيز النظام…</p>
  </main>
</template>

